import CloseIcon from '@mui/icons-material/Close';
import { Box, IconButton } from '@mui/material';
import { observer } from 'mobx-react-lite';

import { rudderstackService } from '@services';
import { useStore } from '@stores';

const style = {
  padding: '0 0.9375rem',
  height: '3rem',
  borderBottom: '1px solid #e8e8e8',
  display: 'flex',
  flexShrink: 0,
  zIndex: 999,
  '@media (max-width:960px)': {
    boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.25)',
    border: 'none',
  },
  alignItems: 'center',
};

export const ModalHeader = observer(() => {
  const {
    formStore,
    commonStore,
    partnerStore: { logos, whiteLabelEnabled },
  } = useStore();
  const { loading, buttonLoading } = commonStore;

  // `buttonLoading` covers an in-flight footer/win-back submit: dismissing the
  // modal mid-submit would expose the host page while the request completes,
  // which the modal buttons and the mobile backdrop already prevent.
  const isBusy = loading || buttonLoading;

  // The header X stays clickable while the win-back is up, so only track the
  // click that opens the prompt — not the one that dismisses it.
  const handleClose = () => {
    if (!formStore.isRampingOff) {
      rudderstackService.workflowExitPrompt();
    }
    formStore.setToggleRampingOff();
  };

  // We want to show the logo on the results module if white label is enabled and the user is on desktop
  // If not, we want to hide the logo on the results module

  return (
    <Box sx={style} justifyContent={'space-between'} data-cy="ModalHeader">
      <Box
        component="img"
        src={logos?.headerLogo}
        data-cy={whiteLabelEnabled ? 'logo-white-label' : 'logo-default'}
        sx={{
          width: { xs: '126px', md: '137px' },
          height: { xs: '24px', md: '26px' },
          objectFit: 'contain',
        }}
      />
      <IconButton
        size="small"
        disabled={isBusy}
        sx={{
          width: '2rem',
          height: '2rem',
          visibility: !isBusy ? 'visible' : 'hidden',
          color: '#878787',
          '@media (max-width: 960px)': {
            color: '#878787',
          },
        }}
        onClick={handleClose}
        aria-label="close-ec"
        data-cy="close-button"
      >
        <CloseIcon />
      </IconButton>
    </Box>
  );
});
